import {useRef, useState} from 'react';
import useWebSocket from "react-use-websocket";
import {toast, snackbar} from "@mobiscroll/react";
import '@mobiscroll/react/dist/css/mobiscroll.min.css';
import Decode from './Decode';

function Websockets(locale, token, session, wss) {
    const [wsResponse, setWsResponse] = useState(null);
    const enabled = useRef(true);
    const time = useRef(null);
    const validateTimer = useRef(null);
    const validateConnection = useRef(false);
    const reconnectAttempt = useRef(0);
    const {sendJsonMessage} = useWebSocket(wss ? Decode(wss) : null, {
        onOpen: () => Open(),
        onClose: () => Close(),
        onError: () => Error(),
        onMessage: (event) => Message(event),
        heartbeat: {
            message: (() => Heartbeat()),
            returnMessage: JSON.stringify({type: 'heartbeat'}),
            timeout: 60000,
            interval: 30000,
        },
        retryOnError: false,
        share: true
    }, enabled.current);

    const Heartbeat = () => {
        const datetime = Date.now();
        const timeout = datetime + 29000;

        if (time.current && datetime > time.current) {
            time.current = null;
            enabled.current = false;

            if (reconnectAttempt.current === 0) {
                Reconnect();
            } else {
                Refresh();
            }
        } else {
            time.current = timeout;
        }
        return JSON.stringify({type: 'heartbeat', token: token});
    }

    const wsCall = data => {
        const item = {...data};
        item.token = token;
        item.session = session;

        try {
            sendJsonMessage(item);
            return true;
        } catch (error) {
            console.log('Error sending message');
            return false;
        }

    };

    const Open = () => {
        if (validateTimer.current) {
            clearTimeout(validateTimer.current);
        }

        validateConnection.current = true;

        const message = {
            token: token,
            type: 'heartbeat'
        };

        try {
            sendJsonMessage(message);

            validateTimer.current = setTimeout(() => {
                if (validateConnection.current) {

                    validateConnection.current = false;
                    Refresh();
                }
            }, 5000);

        } catch (error) {
            console.log('Failed to validate connection');
            validateConnection.current = false;
            Refresh();
        }
    }

    const Close = () => {
        if (validateTimer.current) {
            clearTimeout(validateTimer.current);
        }
        validateConnection.current = false;

        if (wss) {
            if (enabled.current === true) {
                enabled.current = false;
            }

            Reconnect();
        } else {
            toast({message: locale.websocket.a, color: 'info', duration: 1000, display: 'bottom'});
        }
    }

    const Error = () => {

        if (validateTimer.current) {
            clearTimeout(validateTimer.current);
        }
        validateConnection.current = false;

        Refresh();
    }

    const Message = data => {
        const message = JSON.parse(data.data);

        if (message.type === 'heartbeat') {
            time.current = null;

            if (validateConnection.current) {
                validateConnection.current = false;
                reconnectAttempt.current = 0;

                if (validateTimer.current) {
                    clearTimeout(validateTimer.current);
                }

                toast({message: locale.websocket.c, color: 'info', duration: 1000, display: 'bottom'});
            }
        } else {
            setWsResponse(message);
        }
    }

    const Reconnect = () => {

        snackbar({
            message: locale.websocket.b,
            button: {
                text: locale.websocket.d,
                action: function () {
                    enabled.current = true;
                    reconnectAttempt.current = 1;

                    toast({message: locale.websocket.g, color: 'info', duration: false, display: 'center'});

                    const message = {
                        action: 'broadcast',
                        path: 'reconnect',
                        data: {toast: true}
                    };
                    setWsResponse(message);
                }
            },
            color: 'info',
            duration: false,
            display: 'center'
        });
    }

    const Refresh = () => {

        snackbar({
            message: locale.websocket.e,
            button: {
                text: locale.websocket.f,
                action: function () {

                    window.location.reload();
                }
            },
            color: 'info',
            duration: false,
            display: 'center'
        });
    }

    return {wsResponse, wsCall, setWsResponse};
}

export default Websockets;
